import React, { useImperativeHandle,  useRef, forwardRef, useState, useMemo } from "react";
import {RCCHookToast, RCCRefModalProps, RCCServicesApi } from "react-common-components";
import Modal from "src/components/Modal";
import ModalSide from "src/components/Modal/styles";
import { useLoaderBackdrop } from "src/context/LoaderBackdrop/context";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import { IRefModalHistoric, IOccurrence, IHistoric } from "../interface";
import ListHistoric from "./ListHistoric";


const ModalHistoric: React.ForwardRefRenderFunction<IRefModalHistoric> = (_, ref) => {
	const [selectedOccurence, setSelectedOccurence] = useState<IOccurrence>();
	const [historic, setHistoric] = useState<IHistoric[]>();
	const { setLoading } = useLoaderBackdrop();

	const { addToast } = RCCHookToast();

	const modalHistoric = useRef<RCCRefModalProps>(null);
	const { translate } = useTranslation();

	useImperativeHandle(ref, () => ({
		actionButtonHistoric
	}));

	const actionButtonHistoric = (row: IOccurrence) => {
		setLoading(true);
		setSelectedOccurence(row);
		getSelectedOccurenceHistoric(row.ocb001Id);
	};

	const getSelectedOccurenceHistoric = async (id: number) => {

		try{
			const {data} = await RCCServicesApi.getRequest({
				method: "Occurrences/ListHistoric",
				urlParameters: {
					id
				}
			}); 
			setHistoric(data);
			setLoading(false);
			modalHistoric.current?.openModal();				
		}catch(err){
			standardErrorMessages(err, translate("Erro ao carregar o risco"), addToast);
			setLoading(false);
		}
	
		modalHistoric.current?.openModal();	
		setLoading(false);
	};
	
	const ListOfHistoric = useMemo(() => (
		<>
			{historic && (
				<ListHistoric 
					data={historic}
				/>
			)}
		</>
	), [historic]);

  
	return (
		<>
			{selectedOccurence && (
				<>
					<Modal	
						ref={modalHistoric}
						header={{
							title: translate("Histórico de ocorrência"),
							icon: {
								name: "history"
							},
							subtitle:  `${translate("Ocorrência")}: ${selectedOccurence.fullTitle}`
						}}
						styleInline={ModalSide}
						withoutForm
						footer={{
							showSaveButton: false,
							cancelButtonText: translate("Cancelar")
						}}
					>
						{ListOfHistoric}
					</Modal>
				</>
			)}
		</>
	);
}
;


export default forwardRef(ModalHistoric);
